import { useState, useEffect } from 'react'

const avoidArrowScrolling = (e: KeyboardEvent) => {
  if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
    e.preventDefault()
  }
}

export const useKeyPress = (targetKey: string, input: HTMLElement | null) => {
  const [keyPressed, setKeyPressed] = useState(false)

  const handleDown = (e: KeyboardEvent) => {
    avoidArrowScrolling(e)
    if (e.key === targetKey) {
      setKeyPressed(true)
    }
  }

  const handleUp = (e: KeyboardEvent) => {
    avoidArrowScrolling(e)
    if (e.key === targetKey) {
      setKeyPressed(false)
    }
  }

  useEffect(() => {
    if (!input) {
      return
    }

    input.addEventListener('keydown', handleDown)
    input.addEventListener('keyup', handleUp)

    return () => {
      input.removeEventListener('keydown', handleDown)
      input.removeEventListener('keyup', handleUp)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input])

  return keyPressed
}
